import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '@environments/environment';
import * as _ from 'lodash';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CartService } from './cart.service';

@Injectable({
    providedIn: 'root',
})
export class QuotationCartService {

    constructor(
        private http: HttpClient,
        private cartService: CartService
    ) { }

    ///BehaviorSubjects
    private quantitySubject$: BehaviorSubject<number> = new BehaviorSubject(0);
    private qCartSubject$: BehaviorSubject<any> = new BehaviorSubject(
        []
    );
//kkk
    readonly quantity$: Observable<
        number
    > = this.quantitySubject$.asObservable();

    readonly qCart$: Observable<
        number
    > = this.qCartSubject$.asObservable();


    get quantity(): number {
        return this.quantitySubject$.value;
    }

    get qCart(): any {
        return this.qCartSubject$.value;
    }

    cartItems = [];


    addItem(cartItem) {
        return this.http
            .post<any>(`${environment.apiUrl}/quotation-cart/add`, cartItem)
            .pipe(
                tap(
                    (data) =>
                        this.setCart(data.cart),
                    (error) => {

                    }
                ));
    }



    setCart(carts) {
        let cartItems = this.qCart;

        if (!carts) {
            return;
        }
        let cartQuantity = 0;
        if (_.isArray(carts)) {
            cartItems = carts;
            cartQuantity = carts.length
        } else {
            let cartIndex = _.findIndex(cartItems, ["_id", carts._id]);
            if (cartIndex > -1) {
                cartItems[cartIndex] = carts;
            } else {
                cartItems.push(carts);
            }
            cartQuantity = cartItems.length;
        }

        this.quantitySubject$.next(cartQuantity);
        this.qCartSubject$.next(cartItems);
    }

    deleteFromCarts(cartId) {
        let cartItems = this.qCart;
        let cartIndex = _.findIndex(cartItems, ["_id", cartId]);
        let cartQuantity;

        if (cartIndex > -1) {
            cartItems.splice(cartIndex, 1);
            cartQuantity = (cartItems.length > 0) ? cartItems.length : null;
            this.quantitySubject$.next(cartQuantity);
            this.qCartSubject$.next(cartItems);
        }

    }

    getActiveQuotations() {
        return this.http.get<any>(`${environment.apiUrl}/quotations/active`);
    }

    getQuotationHistory() {
        return this.http.get<any>(`${environment.apiUrl}/quotations/history`);
    }

    getQuotationDetails(id) {
        return this.http.get<any>(`${environment.apiUrl}/quotations/${id}`).pipe(
            catchError(error => {

                return of(error)
            }));
    }

    addCommunication(id, formData) {
        return this.http.post<any>(
            `${environment.apiUrl}/quotations/add-communication/${id}`,
            formData
        );
    }


    updateQuotationStatus(action, id) {
        return this.http.post<any>(
            `${environment.apiUrl}/quotations/${action}/${id}`, {}).pipe(tap(data => {
                if (data) {
                    this.cartService.setCart(data.cart)

                }
            }));
    }
    updateCartItem(params) {
        return this.http
            .post<any>(
                `${environment.apiUrl}/quotation-cart/set-amount`,
                params
            ).pipe(tap(data => {
                if (data)
                    this.setCart(data.cart);
            }));
    }

    submit(cartId, userId?) {
        return this.http
            .post<any>(`${environment.apiUrl}/quotation-cart/submit`, {
                cartId: cartId,
            })
            .pipe(
                tap(
                    (data) => {
                        let params: any = {};
                        if (userId) params.userId = userId;
                        this.deleteFromCarts(cartId);
                    },
                    (error) => {
                        //console.log(error);
                    }
                )
            );
    }

    clearCart() {
        return this.http
            .post<any>(
                `${environment.apiUrl}/quotation-cart/clear-cart`,
                {}
            )
            .pipe(
                tap((data) => {
                    this.qCartSubject$.next([]);
                    this.quantitySubject$.next(null);
                })
            );
    }

    saveCartId(params) {
        return this.http.post<any>(
            `${environment.apiUrl}/quotation-cart/save-cartId`,
            params
        );
    }

    printQuotation(id) {
        return `${environment.apiUrl}/quotations/${id}/invoice`;
    }

    addSubmit(cartItem, userId?) {
        return this.http.post<any>(`${environment.apiUrl}/quotation-cart/add-submit`, cartItem);
    }
}
